/**
 * Personal invites (`D275`): route functions, the key and the mutations.
 * Online only, never the outbox (`D163`); both writes are idempotent.
 */
import { INVITE_ROUTES, myInviteOutput, redeemInviteOutput, } from "@repo/contract/community";
import { getJson, sendJson, } from "../core/request";
export const inviteKeys = {
    mine: () => ["community", "invite"],
};
/** `GET /me/invite` — the caller's code and how many came by it. */
export function fetchMyInvite(api, init) {
    return getJson(api, INVITE_ROUTES.mine, myInviteOutput, init);
}
export function myInviteOptions(api) {
    return {
        queryFn: ({ signal }) => fetchMyInvite(api, { signal }),
        queryKey: inviteKeys.mine(),
        staleTime: 60_000,
    };
}
/** `PUT /me/invite` — make the caller's code if there is none. */
export function ensureInviteMutation(api) {
    return {
        invalidates: [inviteKeys.mine()],
        mutationFn: () => sendJson(api, "PUT", INVITE_ROUTES.mine, undefined, myInviteOutput),
        mutationKey: ["community", "invite", "ensure"],
    };
}
/** `POST /me/invite/redeem` — credit the code's owner, once. */
export function redeemInvite(api, code) {
    return sendJson(api, "POST", INVITE_ROUTES.redeem, { code }, redeemInviteOutput);
}
export function redeemInviteMutation(api) {
    return {
        mutationFn: (code) => redeemInvite(api, code),
        mutationKey: ["community", "invite", "redeem"],
    };
}
//# sourceMappingURL=invite.js.map